import React, { useState } from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { LabelGraphStyled } from './styled';

const LabelGraph = ({ theme_standard_label_graph, data }) => {
  const customClass = cx({
    theme_standard_label_graph: theme_standard_label_graph,
  });
  const [selected, setSelected] = useState(1);

  const handleClick = (key) => {
    setSelected(key);
  };

  return (
    <LabelGraphStyled>
      <div className={customClass}>
        {
          data &&
          <div className='group_left_show'>
            {
              data.slice(1, 5).map((e, i) => (
                <div
                  key={i + 1}
                  className={`row_label ${selected === i + 1 ? 'active' : ''}`}
                  style={{ borderColor: e.color }}
                  onClick={() => handleClick(i + 1)}
                >
                  <div className="circle">
                    <div className="bg_color" style={{ background: e.color }} />
                  </div>
                  <div className="label_layer">
                    <div className="group_label">
                      <div>{e.label}</div>
                      <div className="sub_label">{e.labelBottom}</div>
                    </div>
                    <div className="percent">{e.percent}</div>
                  </div>
                </div>
              ))
            }
          </div>
        }
        {
          data &&
          <div className='group_right_show'>
            {
              data.slice(5).map((e, i) => (
                <div
                  key={i + 10}
                  className={`row_label_right ${selected === i + 10 ? 'active' : ''}`}
                  style={{ borderColor: e.color }}
                  onClick={() => handleClick(i + 10)}
                >
                  <div className="circle">
                    <div className="bg_color" style={{ background: e.color }} />
                  </div>
                  <div className="label_layer">
                    <div className="group_label">
                      <div>{e.label}</div>
                      <div className="sub_label">{e.labelBottom}</div>
                    </div>
                    <div className="percent">{e.percent}</div>
                  </div>
                </div>
              ))
            }
          </div>
        }



        {/* {data &&
          data.map((e, i) =>
            e ? (
              <div
                key={i + 1}
                className={`row_label ${selected === i + 1 ? 'active' : ''}`}
                style={{ borderColor: e.color }}
                onClick={() => handleClick(i + 1)}
              >
                <div className="circle">
                  <div className="bg_color" style={{ background: e.color }} />
                </div>
                <div className="label_layer">
                  <div className="group_label">
                    <div>{e.label}</div>
                    <div className="sub_label">{e.labelBottom}</div>
                  </div>
                  <div className="percent">{e.percent}</div>
                </div>
              </div>
            ) : (
              <></>
            )
          )} */}
      </div>
    </LabelGraphStyled>
  );
};

LabelGraph.propTypes = {};

export default LabelGraph;
